module.exports = __webpack_public_path__ + "static/spacy-c1addcda8021ec66980c7a63a41ff416.svg";